import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";
import { useReadComposition } from "./useReadComposition";
import { useCompositionsContext } from "../context/CompositionsContext";
import { useGetCompositionScopesService } from "./useGetCompositionScopesService";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useDropRowsService = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { readComposition } = useReadComposition();
    const { getCompositionScopes } = useGetCompositionScopesService();
    const { selectedComposition } = useCompositionsContext();
    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const dropRows = async ({ permission, private_key, composition, keys }) => {
        setLoading(true);
        try {
            const scopeToUse = (selectedComposition?.selected_scope || selectedAccount || "");
            const res = await fetch(`${URL}/api/database/delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                    scope: scopeToUse,
                    permission: permission,
                    private_key: private_key,
                    composition: composition,
                    keys: keys
                }),
            });

            const data = await res.json();
            setResponse(data);
            if (data?.status) {
                getCompositionScopes({ composition });
                readComposition({ composition: composition });
            }
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    }

    const resetServerStatus = () => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }

    return {
        response,
        loading,
        error,
        dropRows,
        resetServerStatus
    }
}
